<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="6" justify="center">
          <p class="header-title"> {{ $t('department_management.title') }} </p>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" sort-by="email"
                  class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined dense></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn color="primary" dark @click="showAssignProvince(item)">
          {{ $t('location_assign.province_assign') }}
        </v-btn>
      </template>

      <template v-slot:[`item.provinces`]="{ item }">
        <span>{{ convertProvincesToString(item.provinces) }}</span>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-dialog v-model="dialog" max-width="60%" persistent>
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          {{ $t('location_assign.province_assign')}}
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-5">
            <v-autocomplete v-model="selectedProvinces" :items="provinces" item-text="province_name"
                      v-bind:label="$t('location_assign.select_province')" filled outlined multiple return-object>
              <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on">info</v-icon>
                </template>
                <span>Chọn Tỉnh/TP gán cho phòng</span>
              </v-tooltip>
            </v-autocomplete>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn color="primary" @click="closeAssign">
            {{ $t('common.cancel') }}
          </v-btn>

          <v-btn color="primary" @click="assignProvince">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data: () => ({
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    loading: true,

    search: '',
    dialog: false,
    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('department_management.name'), value: 'name'},
      {text: i18n.t('location_assign.province'), value: 'provinces'},
      {text: '', value: 'action', sortable: false}
    ],

    selectedProvinces: [],
    provinces: [],

    desserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ]
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('department_management.add_department') : i18n.t('department_management.edit_department')
    },
  },

  watch: {
    dialog(val) {
      val || this.closeAssign()
    }
  },

  created() {
    this.initialize()
  },

  async mounted() {
    await this.getAll();
    await this.getProvince();
  },

  methods: {
    initialize() {
    },

    showAssignProvince(item) {
      this.dialog = true;
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = item;
      this.selectedProvinces = this.editedItem.provinces;
    },

    closeAssign() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },

    async assignProvince() {
      const self = this;
      if (self.selectedProvinces.length == 0) {
        alert('Chưa chọn Tỉnh/TP');
        return;
      }

      self.editedItem.provinces = self.selectedProvinces;
      const requestBody = self.editedItem;

      try {
        const response = await this.$http.post(process.env.VUE_APP_ADD_PROVINCE_FOR_DEPARTMENT + self.editedItem._id, requestBody);
        if (response.data && response.data.success) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
          self.editedItem = {};
        } else if (response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        console.log(e.stack);
        alert(i18n.t('validate.request_error'));
      }

      this.closeAssign();
    },

    convertProvincesToString(provinces) {
      let result = '';
      provinces.forEach((item, index) => {
        if (index == provinces.length - 1) {
          result = result + item.province_name
        } else {
          result = result + item.province_name + ', ';
        }
      })

      return result;
    },

    async getAll() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_GET_SALE_DEPARTMENT_BY_LEVEL + '?level=1');
        if (response.data && response.data.success) {
          console.log(response.data);
          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);

          this.desserts = contextArr;
          this.loading = false;
        }
      } catch (e) {
        //TODO add alert / flash service to Vue => Like Toast in Android

        //Only print stack trace if development
        console.log(e.stack);
        // dùng vue alert //alert(e.message);
      }
    },

    async getProvince() {
      // try {
      //   const response = await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
      //   if (response.data && response.data.success) {
      //     this.provinces = response.data.data;
      //   }
      // } catch (e) {
      //   console.log(e.stack);
      // }
      this.provinces = await this.$getAllProvinces();
    },
  },

}
</script>
<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>